export default class PackageService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getEntities(params) {
		return this.apiService.callGet('me/geoblocking_private_ip', params)
	}

	createEntity(params){
		return this.apiService.callPost('me/geoblocking_private_ip', params);
	}

	deleteEntity(id, params) {
		return this.apiService.callDelete('me/geoblocking_private_ip/' + id, params)
	}
}



// WEBPACK FOOTER //
// ./src/service/GeoblockingPrivateIpService.js